import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// The Good Book Company — New-customers campaign (adc_n9pdk3c2vh). Real lifetime
// aggregates from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (complete months Nov 2025 – Jul 2026). Monthly series lives in realBrandData.ts.
export const campGbcNew: FaireAdCampaignEntity = {
  token: "camp_gbc_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_good_book_company",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 500,
  startedRunningAt: "2025-11-04",
  segmentMetrics: {
    numCustomersAcquired: 29,
    salesDollars: 14496,
    totalAdsSpendDollars: 2296,
    cpaDollars: 79,
    bestEstimateSalesDollars: 14496,
    bestEstimateRoas: 6.31,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-04T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
